import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import { Hide } from '@s20/components/common/Hide';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../Common';
import { FormCircularProgress, FormValidated } from '../../common/forms/FormElements';
import { DispatchContext } from './DispatchContext';
import { Jobs } from './Jobs';
import { ResourcesContainer } from './Resources';
import { NotificationHandler } from './NotificationHandler';
import { MobileResourceLoader } from './MobileResourceLoader';
import { Filters } from './Filters';
import './index.scss';
import { Footer } from './Footer';

const getPreferredDispatch = () => {
    if (!window.localStorage) {
        return null;
    }

    const preferredDispatch = window.localStorage.getItem(
        'preferredDispatchGroup',
    );

    return preferredDispatch;
};

export const Dispatch = () => {
    const preferredDispatch = getPreferredDispatch();

    const { data, isLoading } = useQuery({
        queryKey: ['dispatchViewModel'],
        queryFn: () => httpClient.js(ApiRoutes.dispatch.viewModel()),
    });

    if (isLoading) {
        return <FormCircularProgress />;
    }

    const {
        dispatchGroups,
    } = data;

    const defaultLocation = preferredDispatch
        ? dispatchGroups.find((loc) => loc.value === preferredDispatch) ?? dispatchGroups[0]
        : dispatchGroups[0];

    return (
        <DispatchContext.Provider value={data}>
            <FormValidated
                id="dispatchPlusDispatch"
                className="d-flex flex-column w-100 flex-fill"
                initialValues={{
                    dispatchGroupId: defaultLocation?.value,
                    dispatchGroupCompanies: defaultLocation?.companyIds ?? [],
                    selectedDate: moment().add(1, 'day').startOf('day').format(),
                    selectedJobId: null,
                    filters: [],
                    jobSearchText: '',
                }}
            >
                {() => (
                    <div className="d-flex position-relative">
                        <div className="pane-left flex-none h-100 d-flex flex-column">
                            <Filters
                                dispatchGroups={dispatchGroups}
                            />

                            <Jobs />

                            <Footer />
                        </div>

                        <Hide mdUp>
                            <div className="pane-right flex-fill h-100">
                                <ResourcesContainer />
                            </div>
                        </Hide>

                        <Hide smDown>
                            <div className="pane-right">
                                <MobileResourceLoader />
                            </div>
                        </Hide>

                        <NotificationHandler />
                    </div>
                )}
            </FormValidated>
        </DispatchContext.Provider>
    );
};